export const CRITICAL_ILLNESS = {
    nickname: 'PRODUCTS.CRITICAL_ILLNESS.shortname',
    isHidden: true,
    lifeInsurance: true,
    icon:'critical-illness'
};
